import { Power0 } from 'gsap'
import TimelineMax from 'gsap/TimelineMax'
import '../lib/DrawSVGPlugin'
import { bindInViewTimeline } from '../util/animations'

class InstagramFeed {
  constructor ($el) {
    this.$el = $el
    this.timelineIn = new TimelineMax({
      paused: true,
      delay: 0.2,
    })
    this.buildTimelineIn()
    bindInViewTimeline($el, this.timelineIn)
  }

  buildTimelineIn () {
    const $el = this.$el
    this.timelineIn
      .staggerFromTo(
        $el.find('.instagram-feed__item'),
        1.2,
        { opacity: 0 },
        { opacity: 1, ease: Power0.easeNone },
        0.3
      )
  }
}

export default InstagramFeed



// WEBPACK FOOTER //
// ./scripts/components/InstagramFeed.js